export const formatDefectValue = (value: number | string | undefined) => {
  if (value === undefined) return undefined;

  if (typeof value === 'string') return undefined;

  // round to 2 decimal places, keep as  a number
  return Number(value.toFixed(2));
};
